import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=5d9f13d4&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=5d9f13d4&prod&lang=css&"
import style1 from "./detail.vue?vue&type=style&index=1&id=5d9f13d4&prod&scoped=true&lang=css&"
import style2 from "./detail.vue?vue&type=style&index=2&id=5d9f13d4&prod&lang=css&"
import style3 from "./detail.vue?vue&type=style&index=3&id=5d9f13d4&prod&lang=css&"
import style4 from "./detail.vue?vue&type=style&index=4&id=5d9f13d4&prod&scoped=true&lang=css&"
import style5 from "./detail.vue?vue&type=style&index=5&id=5d9f13d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9f13d4",
  null
  
)

export default component.exports